export class IntegrationMaintenanceFilters {
    integrationIds: string[];
    destinationEndpointIds: number[];
    importTypeIds: number[];
    clientInformationIds: string[];
    serverIds: string[];
    
    destinationEndpointsString: string;
    importTypesString: string;
    clientInformationsString: string;
    serversString: string;
  }